// src/redux/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: !!localStorage.getItem('token'),
  token: localStorage.getItem('token'),
  branch: JSON.parse(localStorage.getItem('branch')),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      const { token } = action.payload;
      state.isAuthenticated = true;
      state.token = token;
      localStorage.setItem('token', token);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.branch = null;
      localStorage.removeItem('token');
      localStorage.removeItem('branch');
    },
  },
});

export const { login, setBranch, logout } = authSlice.actions;
export default authSlice.reducer;